module.exports = __webpack_public_path__ + "img/autoCadIcon.1e53786c.jpeg";